import { render } from "./CabCardMobile.vue?vue&type=template&id=524f977f&scoped=true"
import script from "./CabCardMobile.vue?vue&type=script&lang=js"
export * from "./CabCardMobile.vue?vue&type=script&lang=js"

import "./CabCardMobile.vue?vue&type=style&index=0&id=524f977f&scoped=true&lang=css"

import exportComponent from "/home/dr/PhpstormProjects/anh/vue/scheduleweek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524f977f"]])

export default __exports__